import { ACTIONS } from "../../shared/hammer-js-wrapper/constants";
import { PRICE_DISCOVERY } from "../../../constants/seller-diy-constants";
// import PostInspectionDiyCarInspection from "../post-inspection-diy-car-inspection";
// import PostInspectionFranchisePriceTab from "../post-inspection-franchise-price-tab";
// import PostInspectionFranchiseDocumentationTab from "../post-inspection-franchise-documentation-tab";
// import PostInspectionFranchiseCarHandoverTab from "../post-inspection-franchise-car-handover-tab";

export const TAB_NAMES = {
    PRICE: "PRICE",
    DOCUMENTATION: "DOCUMENTATION",
    BANK: "BANK",
    DOCUMENTS: "DOCUMENTS",
    PICKUP: "PICKUP",
    SEARCH_LOCATION: "SEARCH_LOCATION",
    CONFIRM_ADDRESS: "CONFIRM_ADDRESS",
    PICKUP_PAYMENT: "PICKUP_PAYMENT",
    DOC_LIST: "DOC_LIST",
    SELF_NEGO_EXPERIMENT: "SELF_NEGO_EXPERIMENT",
    SELF_NEGO: "SELF_NEGO",
    DOCB_CONTEXT: " DOCB_CONTEXT",
    CAR_INSPECTION: "CAR_INSPECTION",
    CAR_HANDOVER: "CAR_HANDOVER",
    HOLDBACKS: "HOLDBACKS"
};

export const DSI_ELIGIBILITY_RESPONSES = {
    DSI: "DSI",
    TOKEN: "TOKEN",
    DSI_OR_TOKEN: "DSI_OR_TOKEN"
};
export const leftSwipeListeners = [
    ACTIONS.PAN_LEFT,
    ACTIONS.SWIPE_LEFT
];

export const rightSwipeListeners = [
    ACTIONS.PAN_RIGHT,
    ACTIONS.SWIPE_RIGHT
];

export const DIY_TAB_STEPS = [
    TAB_NAMES.DOCUMENTATION,
    TAB_NAMES.PRICE,
    TAB_NAMES.SELF_NEGO
];
export const SLOT_STEPS = [
    TAB_NAMES.SEARCH_LOCATION,
    TAB_NAMES.CONFIRM_ADDRESS
];

export const PRICE_DISCOVERY_NOT_OVER = [
    PRICE_DISCOVERY.NOT_STARTED,
    PRICE_DISCOVERY.START,
    PRICE_DISCOVERY.ACCEPTED,
    PRICE_DISCOVERY.NEGOTIATE_PRICE_REQUESTED
];

export const URL_TAGS = {
    CREDIT_REPORT_CONSENT: "creditConsent",
    CREDIT_REPORT_PHONE: "creditPhone"
};

export const NEED_HELP_ALLOWED_SECTION = [
    TAB_NAMES.PICKUP_PAYMENT,
    TAB_NAMES.PRICE
];

export const USER_DETAILS_ALLOWED_SECTIONS = [
    TAB_NAMES.PICKUP_PAYMENT,
    TAB_NAMES.PRICE,
    TAB_NAMES.SELF_NEGO,
    TAB_NAMES.CAR_HANDOVER
];

export const URL_APPLICABLE_PARAMS_LOAN = [ URL_TAGS.CREDIT_REPORT_CONSENT, URL_TAGS.CREDIT_REPORT_PHONE];

export const SELLER_PACKAGE_UI_TYPE = {
    CARD: "CARD",
    STRIP: "STRIP"
};
